import imageuploader from "@newswebsiteapp/shared/lib/imageuploader"
import controllerLoadedObservableFactory from "@newswebsiteapp/shared/observables/controllerLoadedObservableFactory"
import "./newslettergSubscribeModal"
import "./specialDonationSubscribeModal"

import setupAddressFieldsGeocoderAutocomplete from "@newswebsiteapp/shared/lib/setupAddressFieldsGeocoderAutocomplete"

controllerLoadedObservableFactory("profile_account").subscribe(() => {
  const form = $("form#edit_user")

  setupAddressFieldsGeocoderAutocomplete({
    countryInput: form.find("#user_country"),
    stateInput: form.find("#state-input"),
    zipcodeInput: form.find("#user_zipcode"),
    validator: form.validate(),
  })
})

controllerLoadedObservableFactory("profile_account").subscribe(() => {
  imageuploader($(".imageupload"))
})

controllerLoadedObservableFactory("profile_account").subscribe(() => {
  const form = $("form#edit_user")
  const entitiesWithAddressInformationToUpdatePath = form.data(
    "entities-with-address-information-to-update-path"
  )
  if (!entitiesWithAddressInformationToUpdatePath) {
    throw new Error()
  }

  form.find('input[type="submit"]').click((e) => {
    e.preventDefault()

    const update_other_entities = $("#user_update_other_entities").is(
      ":checked"
    )

    if (!update_other_entities) {
      form.submit()
      return
    }

    $.getJSON(entitiesWithAddressInformationToUpdatePath, (data) => {
      if (data.empty) {
        form.submit()
        return
      }

      const { header, text } = data
      const text_ = text.replace(/\n/g, "<br />")
      dataConfirmModal.confirm({
        onConfirm() {
          form.submit()
        },
        title: header,
        text: text_,
      })
    })
  })
})
